export default __webpack_public_path__ + "static/media/tncastle.cb929cc9.jpg";